import { useAuthState } from 'state/useAuthState';

export const useSearchDrawerTabs = (): boolean => {
  const {
    permissions: { canModerate },
  } = useAuthState();

  return canModerate;
};
